import React, { useMemo, useState } from 'react';
import { Box, Container } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import CustomHeader from '../../../General/CustomHeader';
import Page from '../../../Layout/Page';
import FullScreenChartShell from '../../FullScreenChartShell/FullScreenChartShell';
import useStyles from '../../styles';
import DpvChart from './DpvChart';
import DpvConfigContent from './DpvConfigContent';
import { DPV_NAME } from '../../../../constants/graphs';
import { ReduxState } from '../../../../types';
import { generateBreadcrumb } from '../../utils';
import { ModalState, EMPTY_MODAL_STATE } from '../../chartModal';

const DpvConfig = ({ fullScreen }: { fullScreen?: boolean }) => {
  const classes = useStyles();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);

  const { selectedFarm } = useSelector((state: ReduxState) => state.accountFarm);
  const { selectedSector } = useSelector((state: ReduxState) => state.currentSector);

  const [modalState, setModalState] = useState<ModalState>(EMPTY_MODAL_STATE);
  const [conversationsRefreshCounter, setConversationsRefreshCounter] = useState(0);

  const farmId = queryParams.get('farmId') || '';
  const sectorId = queryParams.get('sectorId') || '';

  const breadcrumb = useMemo(() => generateBreadcrumb(
    selectedFarm, selectedSector, DPV_NAME, sectorId,
  ), [selectedFarm, selectedSector]);

  if (fullScreen) {
    return (
      <FullScreenChartShell title="DPV">
        {(h) => (
          <DpvChart
            chartView="fullScreen"
            sectorId={sectorId}
            farmId={farmId}
            externalModalState={modalState}
            externalSetModalState={setModalState}
            hideXValues={false}
            height={`${h}px`}
            onConversationCreated={() => setConversationsRefreshCounter((prev) => prev + 1)}
          />
        )}
      </FullScreenChartShell>
    );
  }

  return (
    <Page className={classes.root} title='Configuración gráfico de DPV'>
      <Container maxWidth={false}>
        <CustomHeader title={breadcrumb} />
        <Box mt={3}>
          <DpvChart
            chartView="settings"
            sectorId={sectorId}
            farmId={farmId}
            externalModalState={modalState}
            externalSetModalState={setModalState}
            onConversationCreated={() => setConversationsRefreshCounter((prev) => prev + 1)}
          />
        </Box>
        <DpvConfigContent
          sectorId={sectorId}
          setModalState={setModalState}
          refreshCounter={conversationsRefreshCounter}
        />
      </Container>
    </Page>
  );
};

export default DpvConfig;
